import { SVGProps } from 'react';

export const RangeOperatorBetween = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="19"
    height="7"
    viewBox="0 0 19 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="4.9541"
      y="2.48438"
      width="8.26085"
      height="1.65213"
      fill="currentColor"
      fillOpacity="0.5"
    />
    <ellipse
      cx="3.30434"
      cy="3.30426"
      rx="3.30434"
      ry="3.30426"
      fill="currentColor"
    />
    <ellipse
      cx="15.695"
      cy="3.30426"
      rx="3.30434"
      ry="3.30426"
      fill="currentColor"
    />
  </svg>
);
